export enum FilterOperators {
    or = 'or',
    and = 'and'
}